<template>
  <div>
    <AnalyticsDashboard type="analytics" />
  </div>
</template>

<script>
import AnalyticsDashboard from '@/modules/intelligence/components/analyticsDashboard'

export default {
  name: 'IntelligenceDashboard',
  components: {
    AnalyticsDashboard
  },
  computed: {
  },
  data() {
    return {
    }
  }
}
</script>
